import { schema, normalize, denormalize } from "normalizr";
import { pipe } from "ramda";

import { Url } from "../router/enums";

import { validator as ACApplicantValidator } from "./AC/Applicant/validator";
import { validator as ACIncidentValidator } from "./AC/Incident/validator";
import { validator as ACPerpetratorValidator } from "./AC/Perpetrator/validator";
import { validator as ACPreloadValidator } from "./AC/Preload/validator";
import { validator as ACSummaryValidator } from "./AC/Summary/validator";
import { validator as ACVehicleValidator } from "./AC/Vehicle/validator";
import { validator as OCPropertyDamagesValidator } from "./OC/Property/Damages/validator";
import { validator as OCPropertyIncidentValidator } from "./OC/Property/Incident/validator";
import { validator as OCPropertyOwnerValidator } from "./OC/Property/Owner/validator";
import { validator as OCPropertyPerpetratorValidator } from "./OC/Property/Perpetrator/validator";
import { validator as OCPropertyPreloadValidator } from "./OC/Property/Preload/validator";
import { validator as OCPropertySummaryValidator } from "./OC/Property/Summary/validator";
import { validator as OCVehicleDamagesValidator } from "./OC/Vehicle/Damages/validator";
import { validator as OCIncidentValidator } from "./OC/Vehicle/Incident/validator";
import { validator as OCIntroductoryValidator } from "./OC/Vehicle/Introductory/validator";
import { validator as OCVehiclePreloadValidator } from "./OC/Vehicle/Preload/validator";
import { validator as OCVehicleSummaryValidator } from "./OC/Vehicle/Summary/validator";
import { validator as OCVehicleOwnerValidator } from "./OC/Vehicle/VehicleOwner/validator";
import { validator as WelcomeValidator } from "./Welcome/validator";
import { validator as genericValidator } from "./validator";

const validator = new schema.Entity("validators");
const validatorSchema = { validators: [validator] };
const validatorData = {
  validators: [
    { id: Url.WELCOME, validator: WelcomeValidator },
    { id: Url.AC, validator: ACPreloadValidator },
    { id: Url.AC_VEHICLE, validator: ACVehicleValidator },
    { id: Url.AC_APPLICANT, validator: ACApplicantValidator },
    { id: Url.AC_INCIDENT, validator: ACIncidentValidator },
    { id: Url.AC_PERPETRATOR, validator: ACPerpetratorValidator },
    { id: Url.AC_SUMMARY, validator: ACSummaryValidator },
    { id: Url.OC_VEHICLE, validator: OCVehiclePreloadValidator },
    { id: Url.OC_VEHICLE_INTRODUCTORY, validator: OCIntroductoryValidator },
    { id: Url.OC_VEHICLE_INCIDENT, validator: OCIncidentValidator },
    { id: Url.OC_VEHICLE_VEHICLE_OWNER, validator: OCVehicleOwnerValidator },
    { id: Url.OC_VEHICLE_DAMAGES, validator: OCVehicleDamagesValidator },
    { id: Url.OC_VEHICLE_SUMMARY, validator: OCVehicleSummaryValidator },
    { id: Url.OC_PROPERTY, validator: OCPropertyPreloadValidator },
    {
      id: Url.OC_PROPERTY_PERPETRATOR,
      validator: OCPropertyPerpetratorValidator,
    },
    { id: Url.OC_PROPERTY_INCIDENT, validator: OCPropertyIncidentValidator },
    { id: Url.OC_PROPERTY_OWNER, validator: OCPropertyOwnerValidator },
    { id: Url.OC_PROPERTY_DAMAGES, validator: OCPropertyDamagesValidator },
    { id: Url.OC_PROPERTY_SUMMARY, validator: OCPropertySummaryValidator },
  ],
};

type ValidatorData = typeof validatorData;

export const normalizedData = normalize(validatorData, validatorSchema);

const denormalizeValidators = (id: string): ValidatorData =>
  denormalize({ validators: [id] }, validatorSchema, normalizedData.entities);

const returnValidator = (data: ValidatorData) =>
  data.validators[0]?.validator || genericValidator;

export const getValidator = pipe(denormalizeValidators, returnValidator);
